import { InjectionToken, inject } from '@angular/core';
import { WorkItemsStore } from './workitems.store';
import type { IWorkItemsStore } from './workitems.public';

export const WORKITEMS_STORE = new InjectionToken<IWorkItemsStore>(
    'WORKITEMS_STORE',
    {
        providedIn: 'root',
        factory: () => inject(WorkItemsStore) as IWorkItemsStore,
    },
);
